<template>
  <div :class="customClass">{{ formatValue }}</div>
</template>

<script>
import _ from 'lodash';
import genericTableService from '@/services/genericConfig/genericTable.utils.js';

/**
 * COMPONENTE DE CELDA DE TABLA PARA MOSTRAR LOS NUMEROS
 * SE PUEDE USAR EN LAS TABLAS O EN OTRO SITIO.
 * */
export default {
  name: 'cell-dt-number-type',
  data() {
    return {};
  },
  props: ['value', 'format', 'outcomes', 'currency', 'area', 'frequency', 'precedent', 'readTransform', 'conditionsDict', 'index'],

  computed: {
    /**
     * Función formatear los números.
     * */
    formatValue() {
      if (this.value == null || this.value === 'undefined') {
        return null;
      }

      let transformedValue;

      if (this.conditionsDict && this.conditionsDict.length > 0) {
        transformedValue = this.getValueFromCondition();
        if (!transformedValue) {
          return null;
        }
      }

      if (this.readTransform) {
        transformedValue = genericTableService.getReadTransform(this.value, this.readTransform);
      }

      const replacedValue = genericTableService.getFormatAndSuffix(this.currency, this.area, this.frequency, this.precedent, transformedValue !== undefined ? transformedValue : this.value, this.format);

      return replacedValue;
    },
    customClass() {
      let cellClass = 'cellNumberType';
      if (this.classToApply) {
        cellClass += ` ${this.classToApply}`;
      }
      return cellClass;
    },
  },

  methods: {
    getValueFromCondition() {
      let found = false;
      let index = 0;
      // Eval expression
      while (!found && index < this.conditionsDict.length) {
        found = this.$parent.fnEvalCondition(this.conditionsDict[index].ValueCondition, this.value, this.index);
        if (!found) {
          index++;
        }
      }
      // Get value if meet condition
      if (found) {
        const expression = this.conditionsDict[index]?.Value?.replace('{{value}}', this.value);
        return expression;
      }
      return null;
    },
  },
};
</script>
<style scoped>
.cellNumberType {
  text-align: right;
}
</style>
